import { ReactNode } from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import SearchBox from '../SearchBox'
import Breadcrumbs from '../Breadcrumbs'
import PopularKeywords from '../PopularKeywords'
import ContactCta from '../ContactCta'
import LegalLinks from '../LegalLinks'

// Types
import type { HelpBreadcrumb } from '@/api/fetchHelpArticle'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  children: ReactNode
  /** 首頁：淺色大標題 + 大搜尋框；其他頁：麵包屑那一列右側放小搜尋框 */
  isHome?: boolean
  /** 內頁麵包屑（上層分類，不含「幫助中心」本身） */
  breadcrumbs?: HelpBreadcrumb[]
  keyword?: string
  /** 實際使用的站點（決定客服入口） */
  countryCode: string
  countryQuery?: string
}

/**
 * 幫助中心各頁共用的外框。
 * 刻意不用品牌粉紅底：header 已經有粉紅的「商品」搜尋，兩個都粉紅會讓人分不清哪個搜文章。
 */
const Shell = ({ children, isHome, breadcrumbs = [], keyword, countryCode, countryQuery }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={cx('help')}>
      {isHome ? (
        <section className={cx('help__hero')}>
          {/* 裝飾用的品牌色光暈 */}
          <span className={cx('help__hero-glow', 'help__hero-glow--pink')} aria-hidden />
          <span className={cx('help__hero-glow', 'help__hero-glow--purple')} aria-hidden />
          <div className={cx('help__hero-inner')}>
            <p className={cx('help__hero-eyebrow')}>{t('Footer_Help_Center')}</p>
            <h1 className={cx('help__hero-title')}>{t('Help_Center_Hero_Title')}</h1>
            <p className={cx('help__hero-subtitle')}>{t('Help_Center_Hero_Subtitle')}</p>
            <SearchBox defaultValue={keyword} countryQuery={countryQuery} />
            <PopularKeywords countryQuery={countryQuery} />
          </div>
        </section>
      ) : (
        <div className={cx('help__toolbar')}>
          <Breadcrumbs items={breadcrumbs} countryQuery={countryQuery} />
          <SearchBox compact defaultValue={keyword} countryQuery={countryQuery} />
        </div>
      )}
      <main className={cx('help__body')}>
        {children}
        <ContactCta countryCode={countryCode} />
        <LegalLinks countryQuery={countryQuery} />
      </main>
    </div>
  )
}

export default Shell
